import React, { useState, useCallback, forwardRef } from "react";
import { Button as AntdButton, Icon, Popconfirm } from "antd";
import * as R from "ramda";
import { useTranslation } from "react-i18next";

import Button from "../../Button";

import SearchAreaModal from "./SearchAreaModal";
import DrawAreaModal from "./DrawAreaModal";

import styled from "styled-components/macro";

const MultipleAreaInputWrapper = styled.div``;

const ENABLE_CUSTOM_AREA_DRAWING = true;

function MultipleAreaLocation({ value = [], onChange }, ref) {
  const { t } = useTranslation("components");
  const [searchVisible, setSearchVisible] = useState(false);
  const [drawVisible, setDrawVisible] = useState(false);

  const deleteLocation = useCallback(
    index => {
      const newValues = R.remove(index, 1, value);
      onChange(newValues);
    },
    [value, onChange]
  );

  return (
    <MultipleAreaInputWrapper ref={ref}>
      {value.map(({ display_name }, i) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            margin: "10px 0"
          }}
          key={i}
        >
          {`${display_name} `}
          <Popconfirm
            placement="topRight"
            title={t("MultipleAreaLocation.deleteConfirm")}
            onConfirm={() => deleteLocation(i)}
            okText={t("global:yes")}
            cancelText={t("global:no")}
          >
            <AntdButton type="danger" icon="delete" />
          </Popconfirm>
        </div>
      ))}

      <div className="row">
        <Button
          type="quaternary"
          onClick={() => setSearchVisible(true)}
          style={{ marginRight: 15, marginBottom: 15 }}
        >
          {t("MultipleAreaLocation.addArea")}
        </Button>
        {ENABLE_CUSTOM_AREA_DRAWING && (
          <Button type="quaternary" onClick={() => setDrawVisible(true)}>
            <Icon type="edit" /> {t("MultipleAreaLocation.addCustomArea")}
          </Button>
        )}
      </div>

      {searchVisible && (
        <SearchAreaModal
          onClose={() => setSearchVisible(false)}
          onSubmit={val => onChange([...value, val])}
          onDraw={() => {
            setSearchVisible(false);
            setDrawVisible(true);
          }}
        />
      )}
      {drawVisible && (
        <DrawAreaModal
          onClose={() => setDrawVisible(false)}
          onSubmit={val => onChange([...value, val])}
        />
      )}
    </MultipleAreaInputWrapper>
  );
}

export default forwardRef(MultipleAreaLocation);
